/**
 * Bridge between the Redux modal slice and the imperative `openModal`
 * call required by the UI library. Whenever the Redux `openedModalId`
 * flips to one of the CPT-codes-related modal IDs, this hook fires
 * `openModal(id)` so the dialog actually appears on screen.
 *
 * @module useOpenModalOnIdChange
 */
import { useEffect } from "react";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../../enums/modalId";

const MODAL_IDS_TO_SYNC: string[] = [
  ModalId.STATUS_UPDATE_MODAL,
  ModalId.UPDATE_CIG_NOTE_CONFIRMATION_DIALOG,
  ModalId.AUTH_INACCURACY_MODAL,
  ModalId.DRAFT_SUBMISSION_MODAL,
  ModalId.NAR_LETTER_MODAL,
  ModalId.DELETE_CONFIRMATION_MODAL,
  ModalId.ADD_NEW_CPT_CODE_MODAL,
];

/**
 * Opens the corresponding UI modal whenever the Redux `openedModalId` changes
 * to one of the CPT-codes-related modal IDs.
 *
 * This bridges the Redux modal state with the imperative `openModal` call
 * required by the UI library.
 */
export const useOpenModalOnIdChange = (openedModalId: string | null) => {
  useEffect(() => {
    if (openedModalId && MODAL_IDS_TO_SYNC.includes(openedModalId)) {
      openModal(openedModalId);
    }
  }, [openedModalId]);
};
